import { render, staticRenderFns } from "./KOLAssignmentTables.vue?vue&type=template&id=ce1f2992&"
import script from "./KOLAssignmentTables.vue?vue&type=script&lang=js&"
export * from "./KOLAssignmentTables.vue?vue&type=script&lang=js&"
import style0 from "./KOLAssignmentTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports